














































































































































































import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { AssetRef } from '@/types';
import { ProjectData } from '@/store/project/types';
import { ProjectActions } from '@/store/project/actions';
import { WorkOrderTableData } from '@/store/planning/types';
import { AssetActions } from '../../store/asset/actions';
import {
  ExportOptions,
  ExportOptionValue,
  ExportType,
  MediaType,
  OptionsObject,
} from './types';

const assetModule = namespace('asset');
const projectModule = namespace('project');

@Component({})
export default class ExportDataPopout extends Vue {
  /**
   * @description List of asset guids
   */
  @Prop() readonly assetGuids: string[];

  /**
   * @description List of work order objectd
   */
  @Prop() workOrderData: WorkOrderTableData[];

  /**
   * @description Set to true if exporter should use inspection guids directly
   * over using asset guids
   */
  @Prop({ type: Boolean, default: false }) exportInspections: boolean

  /**
   * @description List of inspection guids. Only use with exportInspections
   */
  @Prop() readonly inspectionGuids: string[];

  /**
   * @description Custom list of guids to pass to api to further filter query.
   */
  @Prop() readonly filterGuids: string[];

  /**
   * @description Object to controll what menus show up in popup
   */
  @Prop() exportOptionsObject: ExportOptions;

  /**
   * @description Should export inspections based on the work order guid
   */
  @Prop({ type: Boolean, default: false }) exportWorkOrders: boolean

  /**
   * @description Hide the file name formatting menu option
   */
  @Prop({ type: Boolean, default: false }) hideFileNameFormatting: boolean;

  /**
   * @description Hide export type drop down
   */
  @Prop({ type: Boolean, default: false }) hideExportType: boolean;

  /**
   * @description Show Cancel Button
   */
  @Prop({ type: Boolean, default: false }) showCancelButton: boolean;

  exportType = null;

  localExportOptionsObject = null;

  get showExportType(): boolean {
    console.log(this.localExportOptionsObject?.exportTypeCheckboxes);
    return !!this.localExportOptionsObject?.exportTypeCheckboxes?.visible;
  }

  get showMediaOptions(): boolean {
    return !!this.localExportOptionsObject?.mediaTypeCheckboxes?.visible;
  }

  get showValidationOptions(): boolean {
    return !!this.localExportOptionsObject?.validationOptionsSection?.visible;
  }

  get shouldShowExportTypeSection(): boolean {
    return this.showExportType || !!this.exportOptionsObject.csvExportTypeOptions;
  }

  @assetModule.State('exportState') exportState: string;

  @assetModule.Action(AssetActions.EXPORT_ASSETS) exportAssets;

  @projectModule.State('projectGuids') projectGuids: string[];

  @projectModule.Action(ProjectActions.FETCH_PROJECT_DATA) fetchProjectData;

  @projectModule.State('data') project: ProjectData | undefined;

  @Watch('menu')
  onMenuChange(): void {
    if (this.menu === true) {
      this.reset();
    }
  }

  reset(): void {
    this.localExportOptionsObject = JSON.parse(
      JSON.stringify(this.exportOptionsObject),
    );
    this.videoFileNameScheme = this.selectedAssets
      ? this.videoFileNameOptions[2]
      : this.videoFileNameOptions[1];
    if (this.exportOptionsObject.csvExportTypeOptions
    && this.exportOptionsObject.csvExportTypeOptions.length > 0) {
      // eslint-disable-next-line prefer-destructuring
      this.exportType = this.exportOptionsObject.csvExportTypeOptions[0];
    }
  }

  get selectedAssets(): boolean {
    return this.assetGuids?.length === 0;
  }

  get isDbExport(): boolean {
    return (
      this.exportTypeCheckboxes.find((cb) => cb.name === ExportType.DB)
        ?.value === true
    );
  }

  menu = false;

  videoFileNameOptions = ['GUID', 'Assetname_date_time', 'JobNumber_date'];

  get exportTypeCheckboxes(): ExportOptionValue[] {
    return this.localExportOptionsObject?.exportTypeCheckboxes?.options ?? [];
  }

  get mediaTypeCheckboxes(): ExportOptionValue[] {
    return this.localExportOptionsObject?.mediaTypeCheckboxes?.options ?? [];
  }

  exportOptions = [
    'Do not recieve validation email',
  ];

  exportOptionsCheckboxes = Array(this.exportOptions.length).fill(false);

  videoFileNameScheme = '';

  address = '';

  async mounted(): Promise<void> {
    if (this.$auth.user) {
      this.address = this.$auth.user.email;
    }
    if (!this.project) {
      await this.fetchProjectData(this.projectGuids);
    }
    this.reset();
  }

  async exportData(): Promise<void> {
    this.menu = false;
    if (this.project == null || this.project.assets == null) return;
    const optionsObject = {
      projectExportObjectList: [],
      jobOptions: {},
    } as OptionsObject;

    optionsObject.jobOptions.addresses = [this.address];
    optionsObject.jobOptions.videoFileNameScheme = this.videoFileNameScheme;

    // eslint-disable-next-line prefer-destructuring
    optionsObject.jobOptions.pdf = this.exportTypeCheckboxes.find(
      (cb) => cb.name === ExportType.PDF,
    )?.value;
    // eslint-disable-next-line prefer-destructuring
    optionsObject.jobOptions.db = this.exportTypeCheckboxes.find(
      (cb) => cb.name === ExportType.DB,
    )?.value;
    // eslint-disable-next-line prefer-destructuring
    const csvOptions = this.exportTypeCheckboxes.find(
      (cb) => cb.name === ExportType.CSV,
    );
    optionsObject.jobOptions.csv = csvOptions === undefined ? false : csvOptions?.value;

    [
      optionsObject.jobOptions.ignoreValidation,
      optionsObject.jobOptions.ignoreValidationMessage,
    ] = this.exportOptionsCheckboxes;

    optionsObject.jobOptions.videos = this.mediaTypeCheckboxes.find(
      (cb) => cb.name === MediaType.VIDEOS,
    )?.value;
    optionsObject.jobOptions.photos = this.mediaTypeCheckboxes.find(
      (cb) => cb.name === MediaType.PHOTOS,
    )?.value;
    optionsObject.jobOptions.counterIPD = this.mediaTypeCheckboxes.find(
      (cb) => cb.name === MediaType.COUNTER_IPD,
    )?.value;

    optionsObject.jobOptions.exportWorkOrders = this.exportWorkOrders;
    optionsObject.jobOptions.exportInspections = this.exportInspections;
    optionsObject.jobOptions.exportType = this.exportType;

    const projectExportObject = new Map();

    this.assetGuids.forEach((a) => {
      // find assetref in project
      const assetRef = this.project.assets.find(
        (asset) => asset.guid === a,
      ) as AssetRef;
      if (assetRef == null) return;

      if (!projectExportObject.has(assetRef.projectGuid)) {
        projectExportObject.set(assetRef.projectGuid, {
          assetGuids: [],
        });
      }

      const currentProjectExportObject = projectExportObject.get(
        assetRef.projectGuid,
      );

      currentProjectExportObject.assetGuids.push(a);
      projectExportObject.set(assetRef.projectGuid, currentProjectExportObject);
    });
    Array.from(projectExportObject.entries()).forEach((x) => {
      const exportObject = {
        projectGuid: x[0],
        assetGuids: x[1].assetGuids,
      };
      if (this.exportWorkOrders && this.workOrderData) {
        const workOrders = this.workOrderData.flatMap((wo) => {
          if (wo.nodes) {
            return wo.nodes.map((node) => ({
              nodeGuid: node.nodeGuid,
              guid: node.workOrderGuid,
            }));
          }
          return {
            nodeGuid: wo.nodeGuid,
            guid: wo.guid,
          };
        });
        const workorderGuids = workOrders
          .filter((wo) => x[1].assetGuids.includes(wo.nodeGuid))
          .map((wo) => wo.guid);
        exportObject['workorderGuids'] = workorderGuids;
      }
      if (this.exportInspections && this.inspectionGuids) {
        exportObject['inspectionGuids'] = this.inspectionGuids;
      }
      if (this.filterGuids) {
        exportObject['filterGuids'] = this.filterGuids;
      }

      optionsObject.projectExportObjectList.push(exportObject);
    });

    if (optionsObject.projectExportObjectList.length === 0) {
      optionsObject.projectExportObjectList.push({
        projectGuid: this.projectGuids[0],
        assetGuids: [],
      });
    }

    this.$emit('exportData', optionsObject);
    this.exportAssets({ exportOptions: optionsObject }).then(() => {
      // eslint-disable-next-line no-alert
      alert(
        'Your export request has been received.'
          + ' The download links will be sent shortly to the email provided.',
      );
    });
  }
}
